import React from 'react';
import './CSS/policy.css';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-container">
            <div className="privacy-policy-content">
                <h1>PRIVACY POLICY – Sri Sairam Advertising</h1>
                <p className="effective-date">Effective Date: 23 April 2026</p>
                
                <p>
                    At Sri Sairam Advertising, based in Chennai, Tamil Nadu, we are committed to safeguarding your privacy and handling your personal data responsibly in compliance with applicable data protection laws in India, including the Digital Personal Data Protection Act, 2023 (DPDP Act).
                </p>
                <p>
                    This Privacy Policy explains how we collect, use, share, and protect your information when you use our website, services, WhatsApp, calls, or forms for newspaper ad bookings, digital marketing (Google Ads, Facebook, Instagram), bulk SMS/WhatsApp campaigns, or related services.
                </p>

                <hr />

                <section>
                    <h2>1. Information We Collect</h2>
                    <p>We collect only the data necessary to provide our services:</p>
                    <ul>
                        <li><strong>Personal details:</strong> Name, phone number, email address</li>
                        <li><strong>Service-related data:</strong> Advertisement content, booking details, and preferences</li>
                        <li><strong>Usage data:</strong> Information from forms, WhatsApp chats, calls, or website interactions (such as IP address, browser type)</li>
                        <li><strong>Automatically collected data:</strong> Cookies, device information, and analytics data via tools like Google Analytics</li>
                    </ul>
                    <p>We do not intentionally collect sensitive personal data unless required for service processing and payment transactions through secure third-party providers.</p>
                </section>

                <hr />

                <section>
                    <h2>2. How We Use Your Information</h2>
                    <p>Your information is used to:</p>
                    <ul>
                        <li>Process and manage advertisement bookings</li>
                        <li>Communicate regarding campaigns, updates, payments, and support</li>
                        <li>Provide services like ad design and campaign execution</li>
                        <li>Improve our website, services, and marketing efforts</li>
                        <li>Comply with legal and regulatory requirements</li>
                    </ul>
                    <p>By using our website or submitting your details, you consent to the collection and use of your information as described in this policy.</p>
                </section>

                <hr />

                <section>
                    <h2>3. Data Retention</h2>
                    <p>We retain your data only for as long as necessary to fulfill the purposes for which it was collected, including for business, legal, and record-keeping requirements.</p>
                </section>

                <section>
                    <h2>4. Sharing of Information</h2>
                    <p>We do not sell or rent your personal data. We may share your data only when necessary with:</p>
                    <ul>
                        <li>Newspaper publishers for ad placement</li>
                        <li>Advertising platforms such as Google and Meta (Facebook/Instagram)</li>
                        <li>Payment processors for transactions</li>
                        <li>Service providers (such as SMS/WhatsApp gateway providers)</li>
                        <li>Legal authorities, if required by law</li>
                    </ul>
                    <p>All third parties are expected to maintain confidentiality and data protection standards.</p>
                </section>

                <hr />

                <section>
                    <h2>5. Cookies & Tracking</h2>
                    <p>Our website may use cookies and tracking technologies (such as Google Analytics and Meta Pixel) to:</p>
                    <ul>
                        <li>Improve website performance</li>
                        <li>Understand user behavior</li>
                        <li>Show relevant advertisements</li>
                    </ul>
                    <p>You can control cookies through your browser settings. Continued use of the website implies your consent.</p>
                </section>

                <hr />

                <section>
                    <h2>6. Data Security</h2>
                    <p>We implement reasonable security measures such as access controls and secure systems to protect your data.</p>
                    <p>However, no system is completely secure. We will notify you of any data breach as required under applicable laws.</p>
                </section>

                <hr />

                <section>
                    <h2>7. Your Rights (DPDP Act Compliance)</h2>
                    <p>You have the right to:</p>
                    <ul>
                        <li>Access your personal data</li>
                        <li>Correct or update your data</li>
                        <li>Request deletion of your data (subject to legal obligations)</li>
                        <li>Withdraw consent for marketing communications</li>
                    </ul>
                    <p>To exercise your rights, contact us at the email below. We will respond within a reasonable time.</p>
                </section>

                <hr />

                <section>
                    <h2>8. Third-Party Platforms</h2>
                    <p>Our services may involve third-party platforms like Google and Meta. Their data practices are governed by their respective privacy policies.</p>
                    <p>We are not responsible for their policies or practices.</p>
                </section>

                <hr />

                <section>
                    <h2>9. Children’s Privacy</h2>
                    <p>Our services are not intended for individuals under the age of 18. We do not knowingly collect data from children.</p>
                </section>

                <hr />

                <section>
                    <h2>10. Updates to This Policy</h2>
                    <p>We may update this Privacy Policy from time to time. Updates will be posted on this page with the revised effective date.</p>
                </section>

                <hr />

                <section>
                    <h2>11. Advertising Disclaimer</h2>
                    <p>We do not guarantee specific results such as leads, calls, or conversions from advertisements.</p>
                    <p>Ad performance depends on multiple external factors including market conditions, competition, and platform algorithms.</p>
                </section>

                <hr />

                <section>
                    <h2>12. Contact Us</h2>
                    <div className="contact-info">
                        <p><strong>Sri Sairam Advertising</strong></p>
                        <p>Chennai, Tamil Nadu, India</p>
                        <p>📞 +91 9500037429</p>
                        <p>✉️ info@srisairamadvertising.com</p>
                        <p>🌐 <a href="https://srisairamadvertising.com/">https://srisairamadvertising.com/</a></p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
